<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_group'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="220px" >
                        <div class="dialg-form-item"></div>
                        <!--- グループID --->
                        <el-form-item ref="talkgroupName" prop="talkgroupName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_groupId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="talkgroupName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.talkgroupName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- グループ表示名 --->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_group_displayName')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 通話データ保存 --->
                        <el-form-item prop="saveVoice" ref="saveVoice">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_save_voice'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_save_voice')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                <el-select class="select-option-item" v-model="groupOptions.saveVoice" :disabled="appData.e2eEncryption">
                                    <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="saveOption.value"></el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <!--- データの保存先 --->
                        <el-form-item prop="storageSelection" ref="storageSelection">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_data_storage'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_storage_selection')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="selectedStorageIndex" @change="setButtonStatus()" :disabled="storageCandidates.length == 1">
                                <el-option v-for="(candidate, index) in storageCandidates" :key="candidate.name" :label="candidate.name" :value="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- リージョン --->
                        <!---el-form-item ref="region" prop="region">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_region'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_group_region')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="inputForm.region.value" @change="handleChangeRegion()">
                                <el-option v-for="region in regions" :key="region.regionName" :label="region.displayName" :value="region.regionName"></el-option>
                            </el-select>
                        </el-form-item-->
                        <!--- 通話自動終了 --->
                        <el-form-item ref="durationLimit" prop="durationLimit">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_timer'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_talk_timer1'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="durationLimit" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.durationLimit.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 通話形式 --->
                        <el-form-item prop="talkType" ref="talkType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_type'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_talk_type')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="talkType">
                                <el-option v-for="talkType in talkTypeList" :label="talkType.label" :value="talkType.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- かんたんログイン --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_easyLogin'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_easy_login_selection')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="easyLogin" active-color="#5171cb" @change="handleOptionChange('easyLogin')"></el-switch>
                        </el-form-item>
                        <!--- 低ビットレート --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_lowBitRate'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_lowBitRate'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.lowBitRate" active-color="#5171cb" @change="handleOptionChange('lowBitRate')"></el-switch>
                        </el-form-item>
                        <!--- 位置情報オプション --->
                        <el-form-item v-if="isVisibleGroupOption('location')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_location_information'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_locationInGroup'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.location" active-color="#5171cb" @change="handleOptionChange('location')"></el-switch>
                        </el-form-item>
                        <!--- マップ通話オプション --->
                        <el-form-item v-if="isVisibleGroupOption('mapTalk')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_map_talk'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_map_talk'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.mapTalk" active-color="#5171cb" @change="handleOptionChange('mapTalk')"></el-switch>
                        </el-form-item>
                        <!--- サブグループオプション --->
                        <el-form-item v-if="appData.enableSubgroupOption" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_subGroup'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_subGroup'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.subGroup" active-color="#5171cb" @change="handleOptionChange('subGroup')"></el-switch>
                        </el-form-item>

                        <template v-if="showOptionSetting">
                            <!--- hide all options when online purchase / speech-to-text license not exist ---->
                            <!--- 有償オプションの説明 --->
                            <p class="beside-line" v-t="'message.item_option'"></p>
                            <p class="option-description">
                                <span v-if="appData.basicContract.planType == 0" v-t="'message.hint_option_description1'"/>
                                <span v-else v-t="'message.hint_option_description1_plan'"/>
                                <br>
                                <span v-t="'message.hint_option_description3'"/><br>
                                <span>
                                    <span v-t="'message.hint_option_description7_1'"/>
                                    <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('showManual')"><span v-t="'message.menu_manual'"/></a>
                                    <span v-t="'message.hint_option_description7_2'"/>
                                </span>
                            </p>

                            <!--- 音声テキスト化オプション --->
                            <el-form-item v-if="isVisibleGroupOption('speechToTextEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_speechToText'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_speechToText'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.speechToTextEngine" @change="handleOptionChange('speechToTextEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="speechEngine in speechEngineList" :key="speechEngine.type" :label="speechEngine.displayName" :value="speechEngine.type">
                                            <template v-if="speechEngine.tooltip">
                                                <span style="float: left; margin-right: 4px;">{{ speechEngine.displayName }}</span>
                                                <el-tooltip effect="dark" placement="top-start">
                                                    <div slot="content" style="text-align:left" v-html="speechEngine.tooltip"></div>
                                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                                </el-tooltip>
                                            </template>
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                            <!--- 翻訳オプション --->
                            <el-form-item v-if="isVisibleGroupOption('translationEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_translation'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_option_translation')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.translationEngine" @change="handleOptionChange('translationEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="translationEngine in translationEngineList" :key="translationEngine.type" :label="translationEngine.displayName" :value="translationEngine.type"></el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>

                            <template v-if="isVisibleGroupOption('video')">
                                <!--- ライブキャストオプション --->
                                <el-form-item style="text-align:right">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_option_video'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-t="'message.hint_option_video'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-switch v-model="groupOptions.video" active-color="#5171cb" @change="handleOptionChange('video')"></el-switch>
                                </el-form-item>
                                <!--- ライブキャスト保存 --->
                                <el-form-item prop="saveLivecast" ref="saveLivecast">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_save_livecast'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_save_livecast')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                        <el-select class="select-option-item" :disabled="appData.e2eEncryption || !groupOptions.video" v-model="groupOptions.saveLivecast">
                                            <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="!appData.e2eEncryption && saveOption.value"></el-option>
                                        </el-select>
                                    </el-tooltip>
                                </el-form-item>
                                <!--- ライブキャスト自動終了 --->
                                <el-form-item ref="videoDurationLimit" prop="videoDurationLimit">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_video_timer'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-t="'message.hint_video_timer'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-input id="videoDurationLimit" class="input-text-talkgroup" type="text" :disabled="!groupOptions.video" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.videoDurationLimit.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="inputCheck('videoDurationLimit')"/>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="addTalkgroup" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';
import server from './ServerApi.js';
import processorTemplateUtil from './pc/setting/ai-app/AiAppSettingUtil.js';

export default {
    data() {
        return {
            regions: null,
            speechEngineList: [],
            translationEngineList: [],
            saveOptions: [],
            storageCandidates: [],
            talkTypeList: [],
            easyLogin: false,

            disableButton: true,

            inputForm: {
                talkgroupName:      { validationRule: "objectId",       valid: false, value: null,   isComposing: false },
                displayName:        { validationRule: "reqDisplayName", valid: false, value: null,   isComposing: false },
                region:             { validationRule: "selectItem",     valid: true,  value: "AUTO", isComposing: false },
                durationLimit:      { validationRule: "numeric",        valid: true,  value: 60,     isComposing: false },
                videoDurationLimit: { validationRule: "numeric",        valid: true,  value: 60,     isComposing: false },
            },
            talkType: null,
            groupOptions: {
                speechToTextEngine:     0,
                translationEngine:      0,
                saveVoice:              !this.appData.e2eEncryption,
                saveLivecast:           false,
                mapTalk:                false,
                video:                  false,
                lowBitRate:             false,
                subGroup:               false,
                easyLogin:              0,
            },
            savedEngine: {
                speechToTextEngine: 0,
                translationEngine: 0
            },
            selectedStorageIndex: 0,
        };
    },
    created: function() {
        if (this.appData.basicContract.planType != 0) {
            this.speechEngineList = commonUtil.getSpeechToTextEngineListForPlanLicense(this.$i18n);
        } else {
            this.speechEngineList = commonUtil.getSpeechToTextEngineList(this.$i18n);
        }
        this.translationEngineList = commonUtil.getTranslationEngineList(this.$i18n);
        this.saveOptions = commonUtil.getSaveOptions(this.$i18n);
        // this.getRegions();

        // selection of storage
        let storageCandidatesAndIndex = processorTemplateUtil.createStorageCandidateArray(this.$i18n, this.$root.store.processorDefinitionList, null);
        this.storageCandidates = storageCandidatesAndIndex.storageCandidates;

        this.talkTypeList = commonUtil.getTalkTypeList(this.$i18n);
    },
    watch: {
    },
    computed: {
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                // if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                //     return true
                // } else {
                //     if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                //         return true;
                //     } else {
                //         return false;
                //     }
                // }
                if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    methods: {
        addTalkgroup: function() {
            let processorDefinitionIds = null;
            if (this.selectedStorageIndex > 0) {
                let processorDefinitionId = this.storageCandidates[this.selectedStorageIndex].value;
                processorDefinitionIds = [processorDefinitionId];
            }

            if (this.talkType != null) {
                this.groupOptions[this.talkType] = true;
            }

            // in talkgroup creation, there is only an ON/OFF button which can enable easy login type SELECTION.
            // in talkgroup modification, there is a dropdown menu in which we can select easy login type RANDOM, i.e. old version
            if (this.easyLogin) {
                this.groupOptions.easyLogin = constants.EASY_LOGIN_TYPE_SELECTION;
            }

            this.$emit('add', {
                        name: this.inputForm.talkgroupName.value,
                        displayName: this.inputForm.displayName.value,
                        region: this.inputForm.region.value,
                        talkgroupOptions: this.groupOptions,
                        durationLimit: this.inputForm.durationLimit.value,
                        videoDurationLimit: this.inputForm.videoDurationLimit.value,
                        processorDefinitionIds: processorDefinitionIds,
            });
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (eventTargetId == "region") {
                return;
            }
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                if (eventTargetId == "durationLimit" || eventTargetId == "videoDurationLimit") {
                    if (this.inputForm[eventTargetId].value >= 1 && this.inputForm[eventTargetId].value <= 3600) {
                        this.inputForm[eventTargetId].valid = true;
                        this.$refs[eventTargetId].clearValidate();
                    } else {
                        this.inputForm[eventTargetId].valid = false;
                        this.$refs[eventTargetId].validateState = "error";
                        if (this.inputForm[eventTargetId].value < 1) {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_lower_limit");
                        } else {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_higher_limit");
                        }
                    }
                } else {
                    this.inputForm[eventTargetId].valid = true;
                    this.$refs[eventTargetId].clearValidate();
                }
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        handleChangeRegion() {
            this.setButtonStatus();
        },
        handleOptionChange(changedOption) {
            commonUtil.checkChangedGroupOptionCondition(this, changedOption, this.appData, this.groupOptions, this.savedEngine, false, false);
            switch (changedOption) {
                case "video":
                    if(!this.appData.e2eEncryption && this.groupOptions.video) {
                        this.groupOptions.saveLivecast = true
                    } else {
                        this.inputForm.videoDurationLimit.value = 60
                        this.groupOptions.saveLivecast = false
                    }
                    break
                default:
                    break
            }
            this.setButtonStatus();
        },
        getRegions () {
            let self = this;
            this.regions = [];
            server.postNoError('/getregionlist')
            .then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    let regionList = commonUtil.getAWSRegionList();
                    for (let region of res.data.regions) {
                        self.regions.push({regionName: region , displayName: regionList[region].regionName} );
                    }
                    self.regions.push({regionName: "AUTO" , displayName: "AUTO"} );
                    self.inputForm.region.value = self.regions[0].regionName;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getRegions", error);
            });
        },
        isVisibleGroupOption(optionName) {
            // if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
            //     return commonUtil.isVisibleGroupOption(this.appData.onlinePurchase, optionName);
            // } else {
            //     return true;
            // }
            return true;
        },
    },
    props: ['appData']
}
</script>
<style scoped>
.el-select.select-option-item {
    width: 225px;
}

.el-input-number {
    margin-left: 105px;
    width: 120px;
}
</style>
